export default __webpack_public_path__ + "static/media/emptyBowl.611150c1.png";